import cookie from "cookiejs";

// 定义一些公共的属性和方法
const httpUrl = 'http://39.105.17.99:8080/'

let lang = cookie.get('lang')||'zh'

function resizeW() {
    // window.onresize = function(){
        console.log(document.body.clientWidth)
    // }
}
const changeLang = (value)=>{
    cookie("lang", value);
    lang = value
}
// 暴露出这些属性和方法
export default {
    httpUrl,
    resizeW,
    lang,
    changeLang
}